export default "__VITE_ASSET__BYHcqFsK__"